import { useEffect, useMemo, useRef } from "react";
import * as ReactFlow from '@xyflow/react';
import { Typography } from "antd";

import { IItemOption } from "../../../../../../SimuladorInteligente/interfaces"
import { NodeToLinkData } from "../../../../..";
import AddLinkedNodeButton from "../../../../AddLinkedNodeButton";
import { CustomNode } from "../../../../../interfaces";

interface IProps {
  option: IItemOption;
  hideBorderBottom: boolean;
  node: CustomNode;
  hideOptionsConnector: boolean;
  onPressAddLinkedNode: (data: NodeToLinkData) => void;
}

const HandleComponent = ReactFlow.Handle;

export default function Option({
  option,
  hideBorderBottom,
  node,
  hideOptionsConnector,
  onPressAddLinkedNode,
}: IProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const { setEdges } = ReactFlow.useReactFlow();

  const connections = ReactFlow.useNodeConnections({
    id: node.id,
    handleId: option.text,
    handleType: "source",
  });

  const isConnectable = useMemo(() => {
    return !hideOptionsConnector && connections.length === 0;
  }, [hideOptionsConnector, connections]);

  useEffect(() => {
    if (!hideOptionsConnector) {
      return;
    }

    connections.forEach((c) => {
      setEdges((edges) => edges.filter((edge) => edge.id !== c.edgeId))
    });

  }, [hideOptionsConnector, connections]);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        paddingTop: 8,
        paddingBottom: 8,
        paddingRight: 16,
        borderBottom: !hideBorderBottom ? "1px solid #cdcdcd" : 0,
      }}
    >
      <Typography.Text>
        {option.text}
      </Typography.Text>

      {
        !hideOptionsConnector && (
          <HandleComponent
            id={option.text}
            type="source"
            position={ReactFlow.Position.Right}
            isConnectable={isConnectable}
          />
        )
      }

      {
        isConnectable && (
          <AddLinkedNodeButton
            onPress={() => {
              onPressAddLinkedNode?.({
                source: node.id,
                sourceHandle: option.text,
                parentPosition: {
                  x: node.positionAbsoluteX,
                  y: node.positionAbsoluteY,
                },
                parentWidth: node.width,
                offsetTop: containerRef.current?.offsetTop,
              })
            }}
            style={{
              right: -50,
            }}
          />
        )
      }
    </div>
  )
}
